<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: 'RequestItemCard',
    components: {
        RawData
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        withActions: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filtered(){
            let data = this.items;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.items;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        }
    },
    data(){
        return {
            filter: '',
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
        }
    },
    methods: {
        returnItem(item){
            this.$emit('returnItem', item)
        },
        approveItem(item){
            this.$emit('approveItem', item)
        },
        filterItems(items){
            return items.filter((item) => {
                return item.filterKey
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
        },
        viewLog(item){
            this.$emit('viewLog', item)
        },
    }
}
</script>
<template>
    <div>
        <div v-if="loading">
            <h4>Loading...</h4>
        </div>
        <div v-if="!loading && !items.length">
            <h4>No data found...</h4>
        </div>
        <template v-if="!loading && items.length">
            <div id="tickets-table_filter" class="dataTables_filter mb-2">
                <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Item..."
                        class="form-control me-1"
                    ></b-form-input>
                    <b-form-select
                        class="form-select"
                        v-model="perPage"
                        :options="pageOptions"
                        style="width:70px;"
                    ></b-form-select>
                </label>
            </div>
            <ul>
                <li
                    v-for="(y, yIndex) in filtered"
                    :key="yIndex"
                    class="w-100 mb-2"
                >
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="d-flex align-items-center">
                            <a
                                href="javascript:void(0);"
                                class="font-size-18 text-dark"
                                @click="y.showDetails = !y.showDetails"
                                >{{ y.name }} ({{y.count}})
                                <i
                                    class="bx bx-caret-right rotate"
                                    :class="{
                                        'rotate-90': y.showDetails,
                                    }"
                                ></i
                            ></a>
                        </div>
                    </div>
                    <b-collapse :visible="y.showDetails">  
                        <div v-for="(item, index) in filterItems(y.items)" :key="item.id">
                            <div class="card mb-2 position-relative" :style="`z-index:${((filtered.length - yIndex) * filtered.length) + (filterItems(y.items).length - index) + 100}`">
                                <RawData :data="item" v-if="$store.state.decrypt.isAdmin()"/>
                                <div class="card-body py-1 position-relative">
                                    <div class="position-absolute" style="top:10px;right:10px;" v-if="withActions">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i class="fas fa-ellipsis-v"></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="viewLog(item)"
                                                variant="secondary"
                                                ><i class="bx bx-receipt font-size-18 me-1"></i
                                                >View Logs</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="returnItem(item)"
                                                variant="warning"
                                                ><i class="bx bx-chevrons-left font-size-18 me-1"></i
                                                >Return</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="approveItem(item)"
                                                variant="success"
                                                ><i
                                                    class="mdi mdi-check font-size-18 me-1"
                                                ></i
                                                >Approve</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                    <div class="my-2">
                                        <div class="d-inline">
                                            <h5 class="mb-0 d-inline">{{item.itemName}}</h5>
                                            <a href="javascript:void(0);" @click="$emit('updateItem', item)" class="d-inline" v-if="withActions"><i class="bx bx-edit"></i></a>
                                        </div>
                                        <p class="mb-0 text-ellipsis">{{item.description}}</p>
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <span class="badge bg-primary bg-soft me-1">{{item.unit.unitName}}</span>
                                                <span class="badge bg-primary bg-soft me-1">{{item.subType}}</span>
                                                <span class="badge bg-primary bg-soft">{{item.itemCategory.name}}</span>
                                            </div>
                                            <div class="text-right">
                                                <p class="mb-0 font-size-15 text-green font-weight-bold">{{formatCurrency(item.unitCost)}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </li>
            </ul>
            <div v-if="!filtered.length">Search not found...</div>
            <div class="text-center mt-2" v-if="filtered.length">
                <ul
                    class="
                        pagination
                        justify-content-end
                    "
                >
                    <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </template>
    </div>
</template>